import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { getAnswerValuesFromItems } from 'components/Assessments/helpers'
import { AdapterOptions, SectionAdapter } from 'components/Assessments/adapters/types'
import { getSkilledNeedDescription } from 'components/Assessments/constants/skilledNeedsDescriptions'
import { SkilledNeed } from './formData'
import { SkilledNeedsFormField } from './formField'
import { RecertAssessmentQuestionnaireItem } from '../../types/questionnaire'
import { RecertFormData } from '../../types/RecertFormData'

export class SkilledNeedsSectionAdapter extends SectionAdapter<RecertFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<RecertFormData> {
    const skilledNeedsAnswers =
      flatAnswers[RecertAssessmentQuestionnaireItem.SKILLED_NEEDS_NEED]?.answer ?? []
    const skilledNeedsFormData = skilledNeedsAnswers.map<SkilledNeed>((skilledNeedAnswerItem) => {
      const skilledNeedInfoItem = skilledNeedAnswerItem.item ?? []
      const name = getAnswerValuesFromItems(
        skilledNeedInfoItem,
        RecertAssessmentQuestionnaireItem.SKILLED_NEEDS_NEED_NAME
      )?.at(0)

      const score = getAnswerValuesFromItems(
        skilledNeedInfoItem,
        RecertAssessmentQuestionnaireItem.SKILLED_NEEDS_NEED_SCORE
      )?.at(0)

      const note = getAnswerValuesFromItems(
        skilledNeedInfoItem,
        RecertAssessmentQuestionnaireItem.SKILLED_NEEDS_NEED_NOTE
      )?.at(0)

      const previousNote = getAnswerValuesFromItems(
        skilledNeedInfoItem,
        RecertAssessmentQuestionnaireItem.SKILLED_NEEDS_NEED_PREVIOUS_NOTE
      )?.at(0)

      // Description is derived from name and score, not stored directly
      const dynamicDescription = getSkilledNeedDescription(name, score)
      const description = dynamicDescription ? `${score} - ${dynamicDescription}` : 'unknown'

      return {
        [SkilledNeedsFormField.SKILLED_NEED_NAME]: name,
        [SkilledNeedsFormField.SKILLED_NEED_SCORE]: score,
        [SkilledNeedsFormField.SKILLED_NEED_NOTE]: note,
        [SkilledNeedsFormField.SKILLED_NEED_PREVIOUS_NOTE]: previousNote,
        [SkilledNeedsFormField.SKILLED_NEED_DESCRIPTION]: description
      }
    })
    return {
      [SkilledNeedsFormField.SKILLED_NEED]: skilledNeedsFormData
    }
  }

  buildFlatAnswers(_formData: RecertFormData): Array<{ linkId: string; value: unknown }> {
    return []
  }
}
